import React from 'react';
import path from 'path';
import { promises as fs } from 'fs';
import { AgenciesList } from '../../components/Views/AgenciesPage';
import { getSeoData } from '../../utils/helpers';
import Layout from '../../components/Layout/Layout';
import { agenciesQuery } from '../../api/queries';
import initApollo from '../../utils/init-Apollo';
import { getLocaleOnSSR } from '../../utils/helpers/getLocaleOnSSR';
import { getStaticData } from '../../utils/helpers/getStaticData';

const Agencies = props => <AgenciesList {...props} />;

export async function getServerSideProps({ res, req, query }) {
  const apolloClient = initApollo({}, { lang: getLocaleOnSSR(req) });
  const asPath = req.url;

  if (query.mock === 'true' && process.env.NODE_ENV !== 'production') {
    const filePath = path.join(
      process.cwd(),
      'cypress/mock',
      'agenciesMockData.json'
    );
    const file = await fs.readFile(filePath, 'utf-8');
    const mock = JSON.parse(file);

    return { props: { agencies: mock.data.agencies } };
  }

  res.setHeader(
    'Cache-Control',
    'public, max-age=300, s-maxage=300, stale-while-revalidate=86400'
  );

  try {
    const [seoData, agenciesRes, staticData] = await Promise.all([
      getSeoData(apolloClient, asPath, req),
      apolloClient.query({ query: agenciesQuery }),
      getStaticData(apolloClient)
    ]);

    return {
      props: {
        seoData,
        ...staticData,
        agencies: agenciesRes?.data?.agencies || [],
        hasError: false
      }
    };
  } catch {
    return {
      props: {
        seoData: {},
        keywords: [],
        citiesUnPopularList: [],
        regions: {},
        agencies: [],
        hasError: true
      }
    };
  }
}

Agencies.getLayout = (page, pageProps) => (
  <Layout
    isBottomNavigation
    isShowCloseButton={false}
    pageProps={pageProps}
    hideMobileHeader
  >
    {page}
  </Layout>
);

export default Agencies;
